export default __webpack_public_path__ + "static/media/footsteps-silhouette-variant.7de09d93.svg";